export const colorWhite = '#ffffff';
export const colorBlack = '#000000';

export const color9 = '#93a4ac';
export const color16 = '#2d2d2d';
export const color17 = '#f4faf3';

export const colorBlack900 = '#252525';
export const colorBlack800 = '#464646';
export const colorBlack700 = '#666666';
export const colorBlack600 = '#7A7A7A';

export const colorGrey400 = '#8292A4';
export const colorGrey200 = '#D2D9E0';
export const colorGrey100 = '#E5EAEF';
export const colorGrey50 = '#F2F6FA';
export const colorGrey10 = '#F2F4F5';
export const colorGrey15 = 'rgba(0, 0, 0, 0.15)';

export const colorPrimary900 = '#0F5CA0';
export const colorPrimary800 = '#147DC2';
export const colorPrimary700 = '#168ED7';
export const colorPrimary600 = '#19A1EB';
export const colorPrimary500 = '#1CAFFA';
export const colorPrimary400 = '#33BCFB';
export const colorPrimary300 = '#55C8FB';
export const colorPrimary200 = '#84D8FD';
export const colorPrimary100 = '#B5E7FE';
export const colorPrimary50 = '#E2F6FF';

export const colorSecondary900 = '#006B32';
export const colorSecondary800 = '#008C48';
export const colorSecondary700 = '#009D54';
export const colorSecondary600 = '#00B062';
export const colorSecondary500 = '#00C06D';
export const colorSecondary400 = '#00CA83';
export const colorSecondary300 = '#56D49A';
export const colorSecondary200 = '#8FE0B7';
export const colorSecondary100 = '#BCECD3';
export const colorSecondary50 = '#E3F8ED';

export const colorAccent900 = '#CD6800';
export const colorAccent700 = '#D4A700';
export const colorAccent600 = '#F2CB3D';
export const colorAccent400 = '#DBD441';
export const colorAccent200 = '#FAF9E4';
export const colorAccent = '#369D23';

export const colorAttention900 = '#8D0058';
export const colorAttention700 = '#C80064';
export const colorAttention400 = '#F13984';
export const colorAttention200 = '#FCE4EE';

export const colorHighlighting900 = '#0807BE';
export const colorHighlighting700 = '#7003CC';
export const colorHighlighting400 = '#AA3AE0';
export const colorHighlighting200 = '#F4E4FA';

export const colorSurfaceTextSecondary = '#707B80';
export const colorSurfaceTextPrimary = '#141719';
export const colorSurfaceButton = '#262B2E';
export const colorSurfacePositive = '#00C777';
